import { useQuery } from '@apollo/client';
import { ErrorBoundary, JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import LogoProgress from '@jupiterone/jupiter-web-toolkit/src/components/progress/LogoProgress';
import { FetchEdge } from '@jupiterone/jupiter-web-toolkit/src/graphql/queries/queries';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { InspectEdge } from '../../types';
import RelationshipDrawer from './RelationshipDrawer';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    inspectDrawer: {
      width: 400,
      background: theme.palette.common.white,
      boxShadow: `inset 1px 0 ${theme.palette.grey[300]}`,
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      display: 'flex',
      flexFlow: 'column',
    },
    busySpinner: {
      margin: 'auto',
      height: 60,
      width: 60,
    },
  })
);

interface Props {
  inspectedEdge: InspectEdge;
  isOpen: boolean;
  onClose: VoidFunction;
}

export const RelationshipDrawerContainer = ({
  inspectedEdge,
  isOpen,
  onClose,
}: Props) => {
  const classes = useStyles();
  const { data, loading, error } = useQuery(FetchEdge, {
    variables: {
      id: inspectedEdge.id,
    },
    fetchPolicy: 'network-only',
    skip: !isOpen,
  });

  if (!isOpen) return <></>;
  const edge = {
    ...inspectedEdge,
    properties: {
      ...(data?.edge?.properties || inspectedEdge.properties),
      ...data?.edge?.relationship,
    },
  };

  return (
    <div
      className={classes.inspectDrawer}
      data-testid="RelationshipDrawerContainer"
    >
      <ErrorBoundary>
        {error ? (
          '<em>Unable to load relationship details</em>'
        ) : loading ? (
          <LogoProgress className={classes.busySpinner} />
        ) : (
          <RelationshipDrawer edge={edge} onClose={onClose} />
        )}
      </ErrorBoundary>
    </div>
  );
};

export default RelationshipDrawerContainer;
